<div class="title"><ng-content></ng-content></div>
<div class="filter-bar input-container">
    <label for="popular-albums-filter" class="hidden">Filter items</label>
    <input id="popular-albums-filter" [formControl]="filterQuery" #filterInput placeholder="Filter..." trans-placeholder>
    <mat-icon svgIcon="search" class="size-22"></mat-icon>
</div>